import styles from "./CircularProgress.module.css"

export default function CircularProgress({ value = 0, maxValue = 245 }) {
  const radius = 65
  const circumference = 2 * Math.PI * radius

  const percentage = Math.min((value / maxValue) * 100, 100)
  const offset = circumference - (percentage / 100) * circumference

  return (
    <div className={styles.wrapper}>
      <svg className={styles.svg}>
        <circle
          cx="50%"
          cy="50%"
          r={radius}
          strokeWidth="18"
          className={styles.bg}
        />
        <circle
          cx="50%"
          cy="50%"
          r={radius}
          strokeWidth="18"
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          className={styles.progress}
          strokeLinecap="round"
        />
      </svg>

      <div className={styles.centerText}>
        <span className={styles.label}>Total Score</span>
        <span className={styles.value}>{value}</span>
      </div>
    </div>
  )
}
